export default __webpack_public_path__ + "static/media/publishing_schedule.65156c3d.gif";